export const IMAGES = {
  logo: "/logo.png",
  heroPickleJar: "https://static.prod-images.emergentagent.com/jobs/a666c978-012d-4467-86b5-84477213182f/images/cc90b94808ad2b97acd726f967ebb533c576960521a0bb372bfbe643383ac8cd.png",
  andhraAvakaya: "https://static.prod-images.emergentagent.com/jobs/a666c978-012d-4467-86b5-84477213182f/images/e602113119f16d526a72d7fa6aa7210003b6f18e4f32c90763745f826a5efb47.png",
  lemonGingerPickle: "https://static.prod-images.emergentagent.com/jobs/a666c978-012d-4467-86b5-84477213182f/images/e81cda421defc6c88f214af278d4dd71a9f7f8d16e148d57130897e25815a240.png",
  spicePowderCollection: "https://static.prod-images.emergentagent.com/jobs/a666c978-012d-4467-86b5-84477213182f/images/10182c2160436857570589109ef1fa1b91e72ffa602772b514114e934d9fae02.png",
  gunturChilliPickle: "https://static.prod-images.emergentagent.com/jobs/a666c978-012d-4467-86b5-84477213182f/images/e0633df4d8330fe4ab976e604f534a138e748c16c3faea5344875cf449da989c.png",
  garlicKaramPodi: "https://static.prod-images.emergentagent.com/jobs/a666c978-012d-4467-86b5-84477213182f/images/115caea38f555737db609e87d78827430c7675f419918323bd9f0ec49710e21b.png",
  familyMildPodi: "https://static.prod-images.emergentagent.com/jobs/a666c978-012d-4467-86b5-84477213182f/images/d7b627314eace3a43a9cf36610c80805e4a341e7e4dd331b7fffbb9c75d975dd.png",
  methiWellnessPickle: "https://static.prod-images.emergentagent.com/jobs/a666c978-012d-4467-86b5-84477213182f/images/c89c63e0441729629a6992e522232c36475ab261b3703724592a3fda52d15959.png",
  grandmaCooking: "https://images.unsplash.com/photo-1768729340375-5ca3544635d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBncmFuZG1hJTIwY29va2luZyUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3NzM3ODM3NDd8MA&ixlib=rb-4.1.0&q=85",
};

export const PRODUCTS = [
  // ── Andhra ──────────────────────────────────────────────────────────────
  {
    id: "andhra-avakaya",
    name: "Andhra Avakaya",
    category: "Signature Pickles",
    region: "Andhra Pradesh",
    description: "The legendary raw mango pickle from Andhra Pradesh, bold and fiery.",
    image: IMAGES.andhraAvakaya,
    badge: "Best Seller",
    price: 349,
    defaults: { spice: 80, salt: 60, oil: 70, sourness: 60 },
    profiles: ["senior-focused"],
    keyIngredients: ["Raw Mango", "Mustard", "Chilli", "Sesame Oil"],
    customizeHint: "Dial down the spice for a milder Avakaya, or go full fire.",
  },
  {
    id: "guntur-chilli",
    name: "Guntur Chilli Pickle",
    category: "Signature Pickles",
    region: "Andhra Pradesh",
    description: "Intense heat from Guntur chillies, a true spice lover's delight.",
    image: IMAGES.gunturChilliPickle,
    badge: null,
    price: 329,
    defaults: { spice: 90, salt: 55, oil: 65, sourness: 40 },
    profiles: [],
    keyIngredients: ["Green Chilli", "Garlic", "Fenugreek", "Mustard Oil"],
    customizeHint: "Adjust the heat level from warm to volcanic.",
  },
  {
    id: "lemon-ginger",
    name: "Lemon Ginger Pickle",
    category: "Custom Pickles",
    region: "Andhra Pradesh",
    description: "Tangy lemon with warming ginger, a refreshing everyday companion.",
    image: IMAGES.lemonGingerPickle,
    badge: "Profile Friendly",
    price: 299,
    defaults: { spice: 40, salt: 45, oil: 50, sourness: 70 },
    profiles: ["kid-friendly", "diabetic-friendly", "pregnancy-safe"],
    keyIngredients: ["Lemon", "Ginger", "Hing", "Curry Leaves"],
    customizeHint: "Perfect base for kid-friendly or low-sodium versions.",
  },
  {
    id: "methi-wellness",
    name: "Methi Wellness Pickle",
    category: "Health Collections",
    region: "Andhra Pradesh",
    description: "Fenugreek-forward pickle crafted for balanced, everyday wellness.",
    image: IMAGES.methiWellnessPickle,
    badge: "Wellness",
    price: 319,
    defaults: { spice: 35, salt: 30, oil: 40, sourness: 45 },
    profiles: ["heart-healthy", "diabetic-friendly", "senior-focused"],
    keyIngredients: ["Fenugreek", "Amla", "Turmeric", "Sesame Oil"],
    customizeHint: "Built for wellness. Tweak salt & oil to your comfort zone.",
  },

  // ── Maharashtra ──────────────────────────────────────────────────────────
  {
    id: "hirvi-mirchi-thecha",
    name: "Hirvi Mirchi Thecha",
    category: "Marathi Thechas",
    region: "Maharashtra",
    description: "The iconic Maharashtrian green chilli thecha — coarse, fiery, and deeply aromatic with garlic and peanuts.",
    image: IMAGES.gunturChilliPickle,
    badge: "New",
    price: 279,
    defaults: { spice: 85, salt: 50, oil: 30, sourness: 20 },
    profiles: [],
    keyIngredients: ["Green Chilli", "Garlic", "Groundnut", "Salt"],
    customizeHint: "Adjust garlic strength, peanut ratio, and heat to your preference.",
  },
  {
    id: "kanda-lasun-thecha",
    name: "Kanda Lasun Thecha",
    category: "Marathi Thechas",
    region: "Maharashtra",
    description: "Coarse-crushed onion and garlic thecha from Vidarbha, the essential bhakri companion.",
    image: IMAGES.andhraAvakaya,
    badge: "Regional Favourite",
    price: 269,
    defaults: { spice: 70, salt: 55, oil: 25, sourness: 15 },
    profiles: ["senior-focused"],
    keyIngredients: ["Onion", "Garlic", "Dried Red Chilli", "Til Oil"],
    customizeHint: "More garlic for depth, less chilli for everyday use.",
  },
  {
    id: "kairi-lonche",
    name: "Kairi Lonche",
    category: "Marathi Pickles",
    region: "Maharashtra",
    description: "Maharashtrian raw mango pickle — lighter oil, sharper sourness, and the warmth of mustard and hing.",
    image: IMAGES.lemonGingerPickle,
    badge: null,
    price: 299,
    defaults: { spice: 55, salt: 50, oil: 40, sourness: 80 },
    profiles: ["kid-friendly", "pregnancy-safe"],
    keyIngredients: ["Raw Mango", "Mustard Seeds", "Hing", "Turmeric"],
    customizeHint: "A lighter, tangier cousin of Avakaya. Great for everyday eating.",
  },
  {
    id: "methamba",
    name: "Methamba",
    category: "Marathi Pickles",
    region: "Maharashtra",
    description: "A Maharashtrian festive pickle — sweet, sour raw mango tempered with fenugreek and jaggery.",
    image: IMAGES.methiWellnessPickle,
    badge: "Festive",
    price: 289,
    defaults: { spice: 30, salt: 35, oil: 35, sourness: 65 },
    profiles: ["kid-friendly", "senior-focused"],
    keyIngredients: ["Raw Mango", "Jaggery", "Fenugreek", "Mustard"],
    customizeHint: "Balance the sweet-sour ratio to match your family's taste.",
  },
  {
    id: "lal-mirchi-thecha",
    name: "Lal Mirchi Thecha",
    category: "Marathi Thechas",
    region: "Maharashtra",
    description: "Dried red chilli thecha with garlic and sesame — bold, smoky, and deeply satisfying.",
    image: IMAGES.gunturChilliPickle,
    badge: null,
    price: 279,
    defaults: { spice: 88, salt: 52, oil: 28, sourness: 10 },
    profiles: [],
    keyIngredients: ["Dried Red Chilli", "Garlic", "Sesame", "Til Oil"],
    customizeHint: "Smokier and more rounded than green thecha. Adjust the heat freely.",
  },
  {
    id: "kolhapuri-thecha",
    name: "Kolhapuri Thecha",
    category: "Marathi Thechas",
    region: "Maharashtra",
    description: "Fierce Kolhapuri-style thecha with multiple chilli varieties, coarse and unforgiving.",
    image: IMAGES.gunturChilliPickle,
    badge: "Extra Fiery",
    price: 299,
    defaults: { spice: 97, salt: 55, oil: 30, sourness: 15 },
    profiles: [],
    keyIngredients: ["Kolhapuri Red Chilli", "Garlic", "Coriander Seeds", "Oil"],
    customizeHint: "Only for serious heat lovers. Dial down if needed.",
  },
  {
    id: "limbache-lonche",
    name: "Limbache Lonche",
    category: "Marathi Pickles",
    region: "Maharashtra",
    description: "Maharashtrian lemon pickle with a cleaner, sharper profile — less oil, more citrus.",
    image: IMAGES.lemonGingerPickle,
    badge: "Profile Friendly",
    price: 259,
    defaults: { spice: 35, salt: 40, oil: 25, sourness: 85 },
    profiles: ["diabetic-friendly", "pregnancy-safe", "kid-friendly"],
    keyIngredients: ["Lemon", "Mustard Seeds", "Hing", "Turmeric"],
    customizeHint: "Very clean base. Works well for low-oil and low-salt profiles.",
  },
  {
    id: "karela-lonche",
    name: "Karela Lonche",
    category: "Health Collections",
    region: "Maharashtra",
    description: "Bitter gourd pickle in Maharashtrian style — balanced with jaggery to take the edge off the bitterness.",
    image: IMAGES.methiWellnessPickle,
    badge: "Wellness",
    price: 309,
    defaults: { spice: 40, salt: 35, oil: 30, sourness: 40 },
    profiles: ["diabetic-friendly", "heart-healthy", "senior-focused"],
    keyIngredients: ["Karela", "Jaggery", "Mustard", "Turmeric"],
    customizeHint: "Adjust jaggery levels to balance bitterness to your taste.",
  },
];

export const PROFILES = [
  {
    id: "kid-friendly",
    name: "Kid-Friendly",
    icon: "Baby",
    description: "Lower spice, lower salt, no whole chillies, gentler flavors.",
    settings: { spice: 15, salt: 25, oil: 40, sweetness: 20 },
    excludedIngredients: ["Whole Chillies"],
    nutritionNote: "Gentle on young palates",
    color: "#D97706",
  },
  {
    id: "senior-focused",
    name: "Senior-Focused",
    icon: "HeartHandshake",
    description: "Reduced sodium, digestive spices, softer and easier everyday options.",
    settings: { spice: 30, salt: 20, oil: 35, sweetness: 10 },
    excludedIngredients: [],
    nutritionNote: "Low sodium, easy to digest",
    color: "#4A5D23",
  },
  {
    id: "diabetic-friendly",
    name: "Diabetic-Friendly",
    icon: "Activity",
    description: "Thoughtful ingredient suggestions and lower-risk choices for balanced eating.",
    settings: { spice: 40, salt: 25, oil: 30, sweetness: 0 },
    excludedIngredients: [],
    nutritionNote: "Low glycemic, balanced ingredients",
    color: "#2E5C5A",
  },
  {
    id: "heart-healthy",
    name: "Heart-Healthy",
    icon: "HeartPulse",
    description: "Stricter sodium control with smarter oil and ingredient recommendations.",
    settings: { spice: 45, salt: 15, oil: 25, sweetness: 5 },
    excludedIngredients: [],
    nutritionNote: "Low sodium, heart-smart oils",
    color: "#9F3E18",
  },
  {
    id: "pregnancy-safe",
    name: "Pregnancy-Safe",
    icon: "ShieldCheck",
    description: "Carefully adjusted options designed around comfort and caution.",
    settings: { spice: 25, salt: 30, oil: 35, sweetness: 15 },
    excludedIngredients: ["Hing"],
    nutritionNote: "Comfort-first, cautious choices",
    color: "#C8A951",
  },
];

export const INGREDIENTS = [
  { id: "garlic", name: "Garlic" },
  { id: "hing", name: "Hing" },
  { id: "fenugreek", name: "Fenugreek" },
  { id: "sesameOil", name: "Sesame Oil" },
  { id: "wholeChillies", name: "Whole Chillies" },
];

export const TESTIMONIALS = [
  {
    quote: "Finally, a pickle my parents and kids can both enjoy.",
    author: "Priya M.",
    location: "Hyderabad",
  },
  {
    quote: "Feels like home food, but made for my lifestyle.",
    author: "Rahul S.",
    location: "Bangalore",
  },
  {
    quote: "The customization makes it feel like it was made just for us.",
    author: "Ananya K.",
    location: "Mumbai",
  },
  {
    quote: "My grandmother would approve of the taste, my doctor would approve of the sodium.",
    author: "Venkat R.",
    location: "Chennai",
  },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Products", href: "#products" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Smart Profiles", href: "#smart-profiles" },
  { label: "About", href: "/about" },
];

export const getLevelLabel = (value) => {
  if (value <= 20) return "Very Low";
  if (value <= 40) return "Low";
  if (value <= 60) return "Medium";
  if (value <= 80) return "High";
  return "Very High";
};

export const getSodiumEstimate = (salt) => {
  if (salt <= 20) return "Very Low";
  if (salt <= 40) return "Low";
  if (salt <= 60) return "Moderate";
  return "High";
};

export const PICKLE_BASES = [
  // Andhra / common
  { id: "mango",        name: "Mango",           color: "#D97706", description: "Rich, tangy raw mango",          region: "Andhra" },
  { id: "lemon",        name: "Lemon",            color: "#EAB308", description: "Bright, citrusy lemon",          region: "Both" },
  { id: "gongura",      name: "Gongura",          color: "#7C3AED", description: "Tart Andhra sorrel leaves",      region: "Andhra" },
  { id: "garlic",       name: "Garlic",           color: "#92400E", description: "Bold, aromatic garlic",          region: "Both" },
  { id: "tomato",       name: "Tomato",           color: "#DC2626", description: "Ripe, savory tomato",            region: "Both" },
  { id: "mixed",        name: "Mixed Veg",        color: "#059669", description: "Seasonal vegetable medley",      region: "Both" },
  { id: "amla",         name: "Amla",             color: "#65A30D", description: "Indian gooseberry, tangy",       region: "Andhra" },
  { id: "greenChilli",  name: "Green Chilli",     color: "#16A34A", description: "Fresh, fiery chillies",          region: "Both" },
  // Maharashtra
  { id: "hirviMirchi",  name: "Hirvi Mirchi",     color: "#15803d", description: "Thecha-style green chilli",      region: "Maharashtra" },
  { id: "kandaLasun",   name: "Kanda Lasun",      color: "#b45309", description: "Onion & garlic coarse blend",    region: "Maharashtra" },
  { id: "karela",       name: "Karela",           color: "#4d7c0f", description: "Bitter gourd, balanced with jaggery", region: "Maharashtra" },
  { id: "rawTurmeric",  name: "Amba Halad",       color: "#ca8a04", description: "Raw turmeric, earthy & bright",  region: "Maharashtra" },
  { id: "kokum",        name: "Kokum",            color: "#9f1239", description: "Coastal souring agent, deep & tart", region: "Maharashtra" },
  { id: "lalMirchi",    name: "Lal Mirchi",       color: "#b91c1c", description: "Dried red chilli, smoky heat",   region: "Maharashtra" },
];

export const REGIONAL_STYLES = [
  // Andhra / Telangana
  { id: "andhra",        name: "Andhra Style",        description: "Bold, spicy, oil-rich tradition",       region: "Andhra" },
  { id: "telangana",     name: "Telangana Style",      description: "Rustic, earthy, balanced heat",         region: "Andhra" },
  { id: "fiery",         name: "Fiery Traditional",    description: "Maximum heat, full-bodied",             region: "Andhra" },
  { id: "oilRich",       name: "Oil-Rich Classic",     description: "Deeply marinated, rich",                region: "Andhra" },
  // Maharashtra
  { id: "maharashtrian", name: "Maharashtrian Classic",description: "Balanced, home-style, slightly tangy",  region: "Maharashtra" },
  { id: "vidarbha",      name: "Vidarbha Bold",        description: "Spicy & robust, from Amravathi region", region: "Maharashtra" },
  { id: "konkan",        name: "Konkan Style",         description: "Coastal, lighter oil, subtle coconut",  region: "Maharashtra" },
  { id: "kolhapuri",     name: "Kolhapuri Fiery",      description: "Intensely spiced, deep red heat",       region: "Maharashtra" },
  { id: "thechaStyle",   name: "Thecha Style",         description: "Coarse-crushed, raw, minimal oil",      region: "Maharashtra" },
  // Neutral / Cross-regional
  { id: "homestyle",     name: "Homestyle Mild",       description: "Gentle, comforting everyday",           region: "Both" },
  { id: "tangy",         name: "Tangy & Bright",       description: "Citrus-forward, zesty fresh",           region: "Both" },
  { id: "lowOil",        name: "Low-Oil Modern",       description: "Lighter, health-conscious",             region: "Both" },
];

export const TEXTURES = [
  { id: "chunky",       name: "Chunky",        description: "Large irregular pieces with a satisfying bite — the classic pickle cut." },
  { id: "soft",         name: "Soft",           description: "Slow-marinated or tender pieces, easier to eat and gentler on the stomach." },
  { id: "crushed",      name: "Crushed",        description: "Slightly broken down for more surface area, so spices penetrate deeper." },
  { id: "coarseCrushed",name: "Coarse-Crushed", description: "Pounded in a mortar, not blended — the authentic thecha method that keeps texture alive." },
  { id: "fineCut",      name: "Fine-cut",       description: "Thinly sliced pieces that spread easily and blend seamlessly into a meal." },
  { id: "whole",        name: "Whole Pieces",   description: "Intact whole pieces preserved in spice — bold and dramatic, a centerpiece on your plate." },
  { id: "paste",        name: "Paste-style",    description: "Fully blended into a smooth, spreadable consistency — great as a condiment or marinade." },
];

export const STUDIO_INGREDIENTS = [
  // Aromatics
  { id: "garlic",          name: "Garlic",                   category: "Aromatics", default: true,  description: "Pungent and aromatic — adds depth and a slow-building heat to any pickle." },
  { id: "hing",            name: "Hing",                     category: "Aromatics", default: true,  description: "Asafoetida, a resin with a powerful savory aroma. Also aids digestion — a staple in Indian pickling." },
  { id: "ginger",          name: "Ginger",                   category: "Aromatics", default: false, description: "Warming and slightly sharp — brightens lemon and mango-based pickles beautifully." },
  { id: "rawOnion",        name: "Raw Onion",                category: "Aromatics", default: false, description: "Sharp bite with natural sweetness when crushed — essential in Maharashtrian thechas." },
  // Seeds & Spices
  { id: "fenugreek",       name: "Fenugreek",                category: "Seeds",     default: true,  description: "Slightly bitter seeds that add complexity and act as a natural preservative in pickles." },
  { id: "mustardSeeds",    name: "Mustard Seeds",            category: "Seeds",     default: true,  description: "Tiny seeds that pop with flavor when tempered — a core element of most Indian pickle traditions." },
  { id: "corianderSeeds",  name: "Coriander Seeds",          category: "Seeds",     default: false, description: "Warm, citrusy seeds that round out spice profiles — especially important in Kolhapuri-style preparations." },
  { id: "sesame",          name: "Sesame",                   category: "Seeds",     default: false, description: "Nutty, roasted seeds that add body and a mild toasty note — common in Maharashtrian and Andhra pickles." },
  // Fresh
  { id: "curryLeaves",     name: "Curry Leaves",             category: "Fresh",     default: true,  description: "Fragrant herbal leaves that release their full aroma when tempered in hot oil — unmistakably Indian." },
  // Oils
  { id: "sesameOil",       name: "Sesame Oil",               category: "Oils",      default: true,  description: "Light, nutty oil with natural preservative properties — the traditional base oil for Andhra pickles." },
  { id: "mustardOil",      name: "Mustard Oil",              category: "Oils",      default: false, description: "Pungent and assertive with a sharp kick — common in North Indian and some Andhra-style preparations." },
  { id: "tilOil",          name: "Til Oil",                  category: "Oils",      default: false, description: "Cold-pressed sesame (til) oil used in Maharashtrian preparations — slightly darker and more robust than regular sesame oil." },
  // Heat
  { id: "wholeChillies",   name: "Whole Chillies",           category: "Heat",      default: true,  description: "Whole dried or fresh chillies for concentrated heat in every bite — visual and flavor impact." },
  { id: "driedRedChilli",  name: "Dried Red Chilli",         category: "Heat",      default: false, description: "Smoky, deep heat — forms the backbone of thechas and Kolhapuri-style preparations." },
  { id: "extraChilliPowder",name: "Extra Chilli Powder",     category: "Heat",      default: false, description: "Adds intensity without bulk — for when you want more heat without changing the texture of your pickle." },
  // Sweet & Balance
  { id: "jaggeryHint",     name: "Jaggery Hint",             category: "Sweet",     default: false, description: "Just a touch of unrefined cane sugar — barely there, but enough to soften sharp or bitter notes." },
  { id: "jaggery",         name: "Jaggery",                  category: "Sweet",     default: false, description: "Full-bodied jaggery for a proper sweet-sour balance — essential in Methamba and Karela Lonche." },
  // Nuts & Body
  { id: "groundnut",       name: "Groundnut",                category: "Nuts",      default: false, description: "Coarsely crushed roasted peanuts that add earthy richness and body — the soul of Maharashtrian thecha." },
  // Souring
  { id: "kokum",           name: "Kokum",                    category: "Souring",   default: false, description: "Dried purple fruit from the Konkan coast — adds a deep, fruity tang that is very different from lemon or tamarind." },
  { id: "rawTurmeric",     name: "Raw Turmeric (Amba Halad)",category: "Souring",   default: false, description: "Fresh turmeric root — earthy, slightly bitter, and bright. Gives a golden hue and a clean mineral bite." },
];

export const JAR_SIZES = [
  { id: "trial", name: "Trial Jar", weight: "150g", price: 199, description: "Perfect for trying" },
  { id: "regular", name: "Regular Jar", weight: "300g", price: 349, description: "Everyday essential" },
  { id: "family", name: "Family Jar", weight: "500g", price: 499, description: "For the whole family" },
];

export const QUICK_PRESETS = [
  // Andhra / Cross-regional
  { id: "classicAndhra",    name: "Classic Andhra",     description: "Bold raw mango with high spice and generous oil — the Andhra household classic.", base: "mango",       style: "andhra",        spice: 80, salt: 60, oil: 70, sourness: 60, texture: "chunky" },
  { id: "bestForKids",      name: "Best for Kids",      description: "Gentle and mild, with reduced spice and salt — safe and tasty for young ones.",   base: "mango",       style: "homestyle",     spice: 15, salt: 25, oil: 40, sourness: 30, texture: "soft" },
  { id: "lowSaltEveryday",  name: "Low-Salt Everyday",  description: "A light lemon pickle dialled down for everyday health-conscious eating.",          base: "lemon",       style: "lowOil",        spice: 40, salt: 20, oil: 35, sourness: 50, texture: "fineCut" },
  { id: "tangyComfort",     name: "Tangy Comfort",      description: "Citrusy, bright, and punchy — perfect for cutting through rich, heavy food.",       base: "lemon",       style: "tangy",         spice: 30, salt: 40, oil: 45, sourness: 75, texture: "chunky" },
  { id: "extraFiery",       name: "Extra Fiery",        description: "Whole green chilli, maximum heat, minimal compromise — for serious spice lovers.",   base: "greenChilli", style: "fiery",         spice: 95, salt: 55, oil: 65, sourness: 40, texture: "whole" },
  // Maharashtrian
  { id: "hirviThecha",      name: "Hirvi Thecha",       description: "Green chilli pounded coarse with garlic and peanuts — the iconic Maharashtrian thecha.",               base: "hirviMirchi", style: "thechaStyle",   spice: 85, salt: 50, oil: 30, sourness: 20, texture: "coarseCrushed" },
  { id: "kandaLasunThecha", name: "Kanda Lasun Thecha", description: "Onion and garlic coarse-crushed together — the Vidarbha staple eaten with bhakri.",                    base: "kandaLasun",  style: "vidarbha",      spice: 70, salt: 55, oil: 25, sourness: 15, texture: "coarseCrushed" },
  { id: "kairiLonche",      name: "Kairi Lonche",       description: "Lighter Maharashtrian mango pickle — sharper tang, less oil, mustard and hing forward.",               base: "mango",       style: "maharashtrian", spice: 55, salt: 50, oil: 40, sourness: 80, texture: "chunky" },
  { id: "methamba",         name: "Methamba",           description: "Sweet-sour festive mango pickle with jaggery and fenugreek — a Maharashtrian celebration tradition.",  base: "mango",       style: "maharashtrian", spice: 30, salt: 35, oil: 35, sourness: 65, texture: "soft" },
  { id: "kolhapuriFiery",   name: "Kolhapuri Fiery",    description: "Fierce dried red chilli thecha in Kolhapuri style — for those who want real, uncompromising heat.",    base: "lalMirchi",   style: "kolhapuri",     spice: 97, salt: 55, oil: 30, sourness: 15, texture: "coarseCrushed" },
];

export const PRODUCT_STUDIO_MAP = {
  // Andhra
  "andhra-avakaya":      { base: "mango",       style: "andhra" },
  "guntur-chilli":       { base: "greenChilli", style: "fiery" },
  "lemon-ginger":        { base: "lemon",        style: "tangy" },
  "methi-wellness":      { base: "amla",         style: "lowOil" },
  // Maharashtra
  "hirvi-mirchi-thecha": { base: "hirviMirchi",  style: "thechaStyle" },
  "kanda-lasun-thecha":  { base: "kandaLasun",   style: "vidarbha" },
  "kairi-lonche":        { base: "mango",        style: "maharashtrian" },
  "methamba":            { base: "mango",        style: "maharashtrian" },
  "lal-mirchi-thecha":   { base: "lalMirchi",    style: "thechaStyle" },
  "kolhapuri-thecha":    { base: "lalMirchi",    style: "kolhapuri" },
  "limbache-lonche":     { base: "lemon",        style: "konkan" },
  "karela-lonche":       { base: "karela",       style: "maharashtrian" },
};
